import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { FlashMessagesService } from "angular2-flash-messages";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { Router } from '@angular/router';
import { CommonProjectDataService } from "../../_services/common-project-data.service";

export interface DialogData {
  saveFrom: string;
}

@Component({
  selector: 'app-login-client',
  templateUrl: './login-client.component.html',
  styleUrls: ['./login-client.component.css'] 
}) 
export class LoginClientComponent implements OnInit {
  loginClientForm: FormGroup;
  forgotPasswordClientForm: FormGroup;
  loading: false;
  public result = "";
  public validate_address=false;
  public userDetails:any={};
  public countryList:Array<any>=[]; 
  public isPublicQuoteCreation = false;
  public showLoginForm: boolean = true;
  public showForgotPasswordForm: boolean = false;
  public mailMessageStatus: boolean = false;
  public mailMessageText = "";
  constructor(private fb: FormBuilder,
    private _flashMessagesService: FlashMessagesService,
    public dialogRef: MatDialogRef<LoginClientComponent>,
    private CommonService: CommonService,
    private router: Router,
    private CommonProjectDataService: CommonProjectDataService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
    this.loginClientForm = this.fb.group({
      username: [null, [Validators.required, Validators.minLength(5)]],
      password: [null, [Validators.required, Validators.minLength(8)]],
    });

    this.forgotPasswordClientForm = this.fb.group({
      username: [null, [Validators.required, Validators.minLength(5)]]
    });
  }

  ngOnInit() {
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));  
  }

  loginClientFormData = function (postData) {
    if (this.loginClientForm.valid) {
      this.loading = true;
      const formData = new FormData();
      formData.append('id', localStorage.getItem("userID"));
      formData.append('username', postData.username);
      formData.append('password', postData.password);
      formData.append('login_type', 'User');
      this.CommonService.apiService(
        "POST",
        "login",
        formData
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true) {
            response.data.user_id = response.data.id;
            delete response.data.id;
            localStorage.setItem("clientUserDetails", JSON.stringify(response.data));
            this.result = response.data;
            this.onNoClick();
          }
          window.scrollTo(0, 0);
        },
        err => {
          this.loading = false;
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
      ); 
    } else {
      this.validateAllFormFields(this.loginClientForm);
    }
  };

  forgotPasswordClientFormData = function (postData) {
    if (this.forgotPasswordClientForm.valid) {
      this.loading = true;
      const formData = new FormData();
      formData.append('id', localStorage.getItem("userID"));
      formData.append('username', postData.username);
      formData.append('user_type', 'User');
      this.CommonService.apiService(
        "POST",
        "user-password/forgot",
        formData
      ).subscribe(
        (response: any) => {
          this.loading = false;
          console.log("response", response);
          if (response.status === true) {
            this.mailMessageStatus = response.status;
            this.mailMessageText = response.message;
            this.forgotPasswordClientForm.reset({
              username: null
            });
          }
          window.scrollTo(0, 0);
        },
        err => {
          this.loading = false;
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
      ); 
    } else {
      this.validateAllFormFields(this.forgotPasswordClientForm);
    }
  };

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  isFieldValid(field: string) {
    return (
      !this.loginClientForm.get(field).valid &&
      this.loginClientForm.get(field).touched
    );
  }

  isForgotFieldValid(field: string) {
    return (
      !this.forgotPasswordClientForm.get(field).valid &&
      this.forgotPasswordClientForm.get(field).touched
    );
  }

  onNoClick(): void {
    this.dialogRef.close(this.result);
  }

  toggleForm(option) {
    if(option == 'login'){
       this.showLoginForm = true;
      this.showForgotPasswordForm = false;
     
    }
    else if(option == 'forgot-password'){
      this.showLoginForm = false;
      this.showForgotPasswordForm = true;
    }
    
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-master/login-client/login-client.component.ts